var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "41px",
    viewBox: "0 0 40 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Alert") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Additonal-Questions/Alerts/Cards",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oops-Message---Reliant-Colors",
    transform: "translate(-243.000000, -243.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Alert-Message-Small-Icon/2-Lines-Copy-2",
    transform: "translate(202.000000, 219.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "!-copy-2",
    transform: "translate(41.000000, 24.500000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#1E428A",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3511111,24.1777778 L21.92,12.0533333 L22.0622222,8 L17.9377778,8 L18.0444444,12.0533333 L18.6133333,24.1777778 L21.3511111,24.1777778 Z M20,32.2488889 C20.7585185,32.2488889 21.3866667,31.9881481 21.8844444,31.4666667 C22.3822222,30.9451852 22.6311111,30.2814815 22.6311111,29.4755556 C22.6311111,28.6696296 22.3822222,28.0059259 21.8844444,27.4844444 C21.3866667,26.962963 20.7585185,26.7022222 20,26.7022222 C19.2414815,26.7022222 18.6074074,26.962963 18.0977778,27.4844444 C17.5881481,28.0059259 17.3333333,28.6696296 17.3333333,29.4755556 C17.3333333,30.2814815 17.5881481,30.9451852 18.0977778,31.4666667 C18.6074074,31.9881481 19.2414815,32.2488889 20,32.2488889 Z",
    id: "!",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/Alert.5fb540a3bc1accb52388a66c93f09d24.svg";
export { ForwardRef as ReactComponent };